import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SmartMoveShellCommand } from '../../models/smartmove-shell.models';

@Component({
  selector: 'smartmove-command-bar',
  templateUrl: './smartmove-command-bar.component.html',
  styleUrls: ['./smartmove-command-bar.component.scss'],
})
export class SmartMoveCommandBarComponent {
  @Input() commands: Array<SmartMoveShellCommand> = [];
  @Output() commandSelected = new EventEmitter<SmartMoveShellCommand>();

  readonly primaryCommand: SmartMoveShellCommand = {
    id: 'ask-smartmove',
    label: 'Ask SmartMove',
    icon: 'auto_awesome',
  };

  selectPrimaryCommand(): void {
    this.commandSelected.emit(this.primaryCommand);
  }
}
